export default {
	  token: state => state.user.token || false,
	  userInfo: state => state.user.userInfo || {},
    chat_cai: state => state.user.chat_cai || 0,
    chat_uid: state => state.user.chat_uid || 0,
    siteConfig: state => state.setting.siteConfig || {},
    caiList: state => state.setting.caiList || [],
	  roomConfig: state => state.setting.roomConfig || {},
    connecter: state => state.setting.connecter || null,
};



// WEBPACK FOOTER //
// ./src/store/getters.js